// extracted by mini-css-extract-plugin
export default {"warningIcon":"U7KXVlKflcA4EJrv3uA8"};